import {
  HOME_SLIDER
} from "../../constants/actionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  messageId: null,
  lists: []
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case HOME_SLIDER.RESET_HOME_SLIDER: {
      return {
        ...state,
        loader: false,
        alertMessage: '',
        messageId: null
      }
    }

    case HOME_SLIDER.ADD_HOME_SLIDER_REQUEST: {
      return {
        ...state,
        loader: true
      }
    }

    case HOME_SLIDER.ADD_HOME_SLIDER_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 200
      }
    }

    case HOME_SLIDER.ADD_HOME_SLIDER_FAIL: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 203
      }
    }

    case HOME_SLIDER.LIST_HOME_SLIDER_REQUEST: {
      return {
        ...state,
        loader: true
      }
    }

    case HOME_SLIDER.LIST_HOME_SLIDER_SUCCESS: {
      return {
        ...state,
        loader: false,
        messageId: 204,
        lists: action.payload
      }
    }

    case HOME_SLIDER.LIST_HOME_SLIDER_FAIL: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message
      }
    }

    case HOME_SLIDER.DELETE_HOME_SLIDER_REQUEST: {
      return {
        ...state,
        loader: true
      }
    }

    case HOME_SLIDER.DELETE_HOME_SLIDER_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 200,
        lists: action.payload.data
      }
    }

    case HOME_SLIDER.DELETE_HOME_SLIDER_FAIL: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 203
      }
    }

    case HOME_SLIDER.UPDATE_HOME_SLIDER_REQUEST: {
      return {
        ...state,
        loader: true
      }
    }

    case HOME_SLIDER.UPDATE_HOME_SLIDER_SUCCESS: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 200,
        lists: action.payload.data
      }
    }

    case HOME_SLIDER.UPDATE_HOME_SLIDER_FAIL: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload.message,
        messageId: 203
      }
    }

    default:
      return state;
  }
}
